import { useState, type ReactNode } from 'react'
import { Dialog } from '~/components/ui'
import CreatePdfDialogContent, {
  type CreatePdfDialogContentProps,
} from './CreateDialog'

type CreatePdfDialogProps = CreatePdfDialogContentProps & {
  children: ReactNode
}

export default function CreatePdfDialog({
  children,
  listingIds,
  filters,
  initialTitle,
  singleListing,
}: CreatePdfDialogProps) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Dialog modal={false} open={isOpen} onOpenChange={setIsOpen}>
      <Dialog.Trigger asChild>{children}</Dialog.Trigger>
      {isOpen && (
        <CreatePdfDialogContent
          listingIds={listingIds}
          filters={filters}
          initialTitle={initialTitle}
          singleListing={singleListing}
        />
      )}
    </Dialog>
  )
}
